import { render, staticRenderFns } from "./app-offlineSearch.vue?vue&type=template&id=2588a420"
import script from "./app-offlineSearch.vue?vue&type=script&lang=js"
export * from "./app-offlineSearch.vue?vue&type=script&lang=js"
import style0 from "./app-offlineSearch.vue?vue&type=style&index=0&id=2588a420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports